var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('portal',{attrs:{"to":"toolbar-title"}},[_vm._v(" Αρχική")]),(_vm.isMobile)?_c('home-mobile'):_c('home-desktop')],1)}
var staticRenderFns = []

export { render, staticRenderFns }